import { cn } from "@/lib/utils";

export const TrackerStat = ({
  label,
  value,
}: {
  label: string;
  value: string | number;
}) => {
  return (
    <div
      className={cn(
        "flex flex-1 items-center justify-between rounded-md border border-slate-200 p-3 shadow-sm shadow-primary-200",
      )}
    >
      <p className="text-sm font-medium text-slate-600">{label}</p>
      <p className="font-medium">{value}</p>
    </div>
  );
};
